module.exports = __webpack_public_path__ + "media/video505.cbaa757c.mp4";